import {
    CONSUMER_CHANGE_FILTERS,
    CONSUMER_MODE,
    CONSUMER_RATE_MODE,
} from '../../../../../constants/navigation/tabs/consumer';
import {type TPerformanceCounters} from '../../../../../store/reducers/navigation/tabs/queue/types';
import {mergeStateOnClusterChange} from '../../../../../store/reducers/utils';
import {type ActionD} from '../../../../../types';
import {type ConsumerQueueInfo} from './status';
import i18n from './i18n';

export interface PartitionColumn<Names> {
    name: Names;
    checked: boolean;
    caption: string;
    keyColumn?: boolean;
    disabled?: boolean;
}

export type ConsumerPartitionsColumns =
    | 'partition_index'
    | 'error'
    | 'read_rate'
    | 'next_row_index'
    | 'unread_row_count'
    | 'processing_lag'
    | 'next_row_commit_time';

const CONSUMER_PARTITIONS_COLUMNS: Array<{id: ConsumerPartitionsColumns; caption: string}> = [
    {id: 'partition_index', caption: '#'},
    {
        id: 'error',
        get caption() {
            return i18n('field_error');
        },
    },
    {
        id: 'read_rate',
        get caption() {
            return i18n('field_read-rate');
        },
    },
    {
        id: 'next_row_index',
        get caption() {
            return i18n('field_next-row-idx');
        },
    },
    {
        id: 'unread_row_count',
        get caption() {
            return i18n('field_unread-rows');
        },
    },
    {
        id: 'processing_lag',
        get caption() {
            return i18n('field_processing-lag');
        },
    },
    {
        id: 'next_row_commit_time',
        get caption() {
            return i18n('field_next-row-commit-time');
        },
    },
];

export interface ConsumerFiltersState {
    consumerMode: CONSUMER_MODE;
    consumerPartitionIndex: string;
    consumerRateMode: CONSUMER_RATE_MODE;
    consumerTimeWindow: keyof TPerformanceCounters;
    partitionsColumns: Array<PartitionColumn<ConsumerPartitionsColumns>>;
    targetQueue: ConsumerQueueInfo | undefined;
}

export const initialState: ConsumerFiltersState = {
    consumerMode: CONSUMER_MODE.METRICS,
    consumerPartitionIndex: '',
    consumerRateMode: CONSUMER_RATE_MODE.ROWS,
    consumerTimeWindow: '1m',
    partitionsColumns: CONSUMER_PARTITIONS_COLUMNS.map(({id, caption}) => ({
        name: id,
        caption,
        checked: true,
    })),
    targetQueue: undefined,
};

function reducer(state = initialState, action: ConsumerFiltersAction): ConsumerFiltersState {
    switch (action.type) {
        case CONSUMER_CHANGE_FILTERS:
            return {...state, ...action.data};

        default: {
            return state;
        }
    }
}

export type ConsumerFiltersAction = ActionD<
    typeof CONSUMER_CHANGE_FILTERS,
    Partial<ConsumerFiltersState>
>;

export default mergeStateOnClusterChange(initialState, {}, reducer);
